var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",class:[_vm.css(), _vm.css('', _vm.type), _vm.css('', _vm.size)],attrs:{"data-test":"atom-link"}},'component',Object.assign({}, _vm.attrs,
    _vm.$attrs),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }